import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Auth/Login';
import ResetPassword from './components/Auth/ResetPassword';
import AdminLayout from './components/Layout/AdminLayout';
import Dashboard from './components/Dashboard/Dashboard';
import Consumers from './components/Consumers/Consumers';
import ConsumerForm from './components/Consumers/ConsumerForm';
import ConsumerDetails from './components/Consumers/ConsumerDetails';
import Attendance from './components/Attendance/Attendance';
import Measurements from './components/Measurements/Measurements';
import Payments from './components/Payments/Payments';
import Centers from './components/Centers/Centers';
import Coaches from './components/Coaches/Coaches';
import Profile from './components/Profile/Profile';
import Inventory from './components/Inventory/Inventory';
import './App.css';

// App Routes Component
const AppRoutes = () => {
  const { user } = useAuth();

  // Allow /reset-password without auth
  const path = window.location.pathname;
  if (path === '/reset-password') {
    return <ResetPassword />;
  }

  if (!user) {
    return <Login />;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/attendance" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />

        {/* Super Admin Routes: Wellness Centers Management Only */}
        {user.role === 'super_admin' ? (
          <>
            <Route path="/centers" element={<Centers />} />
            {/* Redirect Super Admin away from consumer management */}
            <Route path="/consumers/*" element={<Navigate to="/centers" replace />} />
            <Route path="/attendance" element={<Navigate to="/centers" replace />} />
            <Route path="/measurements" element={<Navigate to="/centers" replace />} />
            <Route path="/payments" element={<Navigate to="/centers" replace />} />
          </>
        ) : (
          <>
            {/* Center Admin Routes: Consumer Operations Management */}
            <Route path="/consumers" element={<Consumers />} />
            <Route path="/consumers/new" element={<ConsumerForm />} />
            <Route path="/consumers/:id" element={<ConsumerDetails />} />
            <Route path="/consumers/:id/edit" element={<ConsumerForm />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/measurements" element={<Measurements />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/inventory" element={<Inventory />} />
            {/* Redirect Center Admin away from centers management */}
            <Route path="/centers" element={<Navigate to="/consumers" replace />} />
          </>
        )}

        <Route path="*" element={<Navigate to="/attendance" replace />} />
      </Routes>
    </AdminLayout>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
